// extracted by mini-css-extract-plugin
export default {"shiftPatternTooltip":"_shiftPatternTooltip_B_hfG","stickyZIndex":"_stickyZIndex_ut78G","overflowCellContent":"_overflowCellContent_bv0YY"};